import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Lock, ShieldCheck, Server, MapPin } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];
const ICONS = [Lock, ShieldCheck, Server, MapPin];
const TRUST_BG = "https://images.pexels.com/photos/30766684/pexels-photo-30766684.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Trust = () => {
  const { t } = useTranslation();
  const cards = t("trust.cards", { returnObjects: true });

  return (
    <section id="security" data-testid="trust-section" className="relative py-24 lg:py-36 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
        <img src={TRUST_BG} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-mint mb-4">{t("trust.kicker")}</p>
          <h2 className="font-display font-semibold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl text-balance">
            {t("trust.title")}
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/55">{t("trust.sub")}</p>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cards.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: EASE }}
                data-testid={`trust-card-${i}`}
                className="group rounded-2xl border border-white/8 bg-night/70 backdrop-blur-md p-7 transition-colors duration-300 hover:border-mint/30"
              >
                <div className="w-11 h-11 rounded-xl bg-mint/10 border border-mint/20 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-mint" strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-display font-semibold text-white text-lg tracking-tight">{c.title}</h3>
                <p className="mt-3 text-sm text-white/55 leading-relaxed">{c.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
